import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { notify } from '../../../../assets/helpers/toast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import {
  idCodes,
  planTypes,
  vehicleDocumentTypeOptions,
  externalvehicleDocumentTypeOptions,
  documentTypeEnum,
  getVehicleBrandsPlanParam,
} from '../../../../assets/helpers/options';
import { statesService } from '../../../../services/statesService';
import { vehicleService } from '../../../../services/vehicleService';
import { armorTypesService } from '../../../../services/armorTypesService';
import { membershipService } from '../../../../services/membershipService';
import {
  clearObject,
  capitalize,
  filterSatesMotoriderAV,
  removeBlankSpacesAndUppercase,
  validateAndSet,
  convertToBase64,
  convertBase64ToFile,
  filterOptionById,
  findOptionByFuzzyName,
} from '../../../../assets/helpers/funciones';
import {
  SalesDropzone,
  FileComponent,
} from '../../../common/Dropzone/Dropzone';
import { useParams } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import './LandingForms.scss';
import authService from '../../../../services/authService';
import { RcvHolderForm } from '../../../common/Forms/Form';
import { Autocomplete, LoadScript } from '@react-google-maps/api';
import {
  preloadVehicleData,
  handleTestImageUpload,
  resolvePreloadTypeId,
  generateRandomPlate,
} from './helpers/preloadFuntions';
import { useVehicleClassesStore } from '../../../../stores/useVehicleClassesStore';

export const CreateVehicleForm = React.memo((props) => {
  const {
    setcurentStep,
    curentStep,
    membership,
    vehicle,
    customer,
    selectedMembership,
  } = props;

  const initialized = useRef(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    setError,
  } = useForm({
    resolver: yupResolver(schemas.RegisterVehicleSchema()),
  });

  const destinyRef = useRef();

  const [statesOptions, setStatesOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [ownerCitiesOptions, setOwnerCitiesOptions] = useState([]);
  const [RCVCitiesOptions, setRCVCitiesOptions] = useState([]);
  const [armorTypeOptions, setArmorTypeOptions] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);
  const [vehileError, setVehicleError] = useState(false);
  const [vehicleBrandOptions, setVehicleBrandOptions] = useState([]);
  const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [municipalitiesOptions, setMunicipalitiesOptions] = useState([]);
  const [circulationCard, setcirculationCard] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [customerIsOwner, setcustomerIsOwner] = useState('SI');
  const [isVehicleDriver, setIsVehicleDriver] = useState('SI');
  const { saleChannel } = useParams();

  const getDocumentsData = (file, documentType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);

    setIsloading(true);
    membershipService
      .getDocumentsDataV2(formData)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          const res =
            response?.data?.[`${documentType}`] ||
            response?.data?.[`${documentType?.toUpperCase()}`] ||
            response?.data?.circulation ||
            {};
          if (!['true', true].includes(process.env.REACT_APP_DEVELOP)) {
            validateAndSet('plate', res?.plate, setValue, watch);
          }
          // validateAndSet('year', res?.year, setValue, watch);
          validateAndSet('bodySerial', res?.bodySerial, setValue, watch);
          validateAndSet('color', capitalize(res?.color), setValue, watch);
          validateAndSet('seats', res?.seats, setValue, watch);
          // Intentar inferir la clase primero (si viene en el OCR) y setearla,
          // luego solicitar los tipos usando esa clase para asegurar resultados.
          (async () => {
            try {
              const classId = watch('class');

              if (classId) {
                setValue('class', classId);
              }

              const types = await getVehicleTypes(classId);
              if (types && types.length > 0) {
                const selectedType = findOptionByFuzzyName(types, res?.type);
                if (selectedType) {
                  setValue('type', selectedType?._id);
                }
              }
            } catch (e) {}
          })();
          Promise.all([getVehicleBrands()]).then(([brands]) => {
            if (brands.length > 0) {
              const selectedBrand = findOptionByFuzzyName(brands, res?.brand);
              if (selectedBrand) {
                setValue('brand', selectedBrand?._id);
                getVehicleModels(selectedBrand?._id).then((models) => {
                  if (models && models.length > 0) {
                    const selectedModel = findOptionByFuzzyName(
                      models,
                      res?.model
                    );
                    if (selectedModel) {
                      setValue('model', selectedModel?._id);
                    }
                  }
                });
              }
            }
          });
          setIsloading(false);
        } else {
          setIsloading(false);
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const onDrop1 = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        // Do whatever you want with the file contents
      };
      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setcirculationCard(file);
        getDocumentsData(file, watch('documentTypeImage'));
      }
    });
  }, []);

  const updateLocationStatus = () => {
    setValue('address', destinyRef.current.value);
    // Check if any state name matches a substring in destinyRef.current.value
    const matchedState = statesOptions.find(
      (state) =>
        destinyRef.current.value &&
        typeof destinyRef.current.value === 'string' &&
        destinyRef.current.value
          .toLowerCase()
          .includes(state.name.toLowerCase())
    );

    if (matchedState) {
      setValue('state', matchedState._id);
      getAndSetCities(matchedState._id);
    }
  };

  const handleRequired = (name) => {
    if (!watch(name)) {
      setError(name, { type: 'custom', message: 'Obligatorio' });
      return true;
    } else return false;
  };

  const onSubmit = handleSubmit(async (data) => {
    setVehicleError(false);

    if (membership?.rcv !== 'N/A') {
      let error = false;

      if (handleRequired('seats')) {
        error = true;
      }
      if (handleRequired('bodySerial')) {
        error = true;
      }

      if (error) {
        return null;
      }
    }

    data.plate = data?.plate?.toUpperCase();
    data.bodySerial = data?.bodySerial?.toUpperCase();
    data.color = capitalize(data?.color);

    if (!circulationCard && !saleChannel) {
      // notify('Adjunte su carnet de circulación', 'info');
      notify('Adjunte su título de propiedad del vehículo', 'error');
      setVehicleError(true);
      return null;
    }

    data.rcvHolder = {
      isVehicleDriver: isVehicleDriver === 'SI' ? true : false,
      firstName: data?.rcvHolderFirstName,
      lastName: data?.rcvHolderLastName,
      fullName: `${data?.rcvHolderFirstName} ${data?.rcvHolderLastName}`,
      identificationType: data?.rcvHolderIdentificationType,
      identification: data?.rcvHolderIdentification,
      phonePrefix: data?.rcvHolderPhonePrefix,
      phoneNumber: data?.rcvHolderPhoneNumber,
      address: data?.rcvHolderAddress,
      state: data?.rcvHolderState,
      city: data?.rcvHolderCity,
    };
    data.rcvHolder = clearObject(data.rcvHolder);
    data = clearObject(data);

    if (!data?.rcvHolderFirstName && !data?.rcvHolderLastName) {
      delete data.rcvHolder.fullName;
    }

    delete data.rcvHolderFirstName;
    delete data.rcvHolderLastName;
    delete data.rcvHolderIdentificationType;
    delete data.rcvHolderIdentification;
    delete data.rcvHolderPhonePrefix;
    delete data.rcvHolderPhoneNumber;
    delete data.rcvHolderAddress;
    delete data.rcvHolderState;
    delete data.rcvHolderCity;
    delete data.isVehicleDriver;

    let vehicle = { ...data };

    if (filterOptionById(armorTypeOptions, watch('armorType'))?.name !== 'No') {
      delete vehicle.armorType;
    }

    delete vehicle.documentTypeImage;

    let fileTopost = appendFile(vehicle);
    vehicle.brandName = capitalize(
      vehicleBrandOptions?.filter((c) => c?._id === vehicle?.brand)[0]?.name
    );
    vehicle.modelName = vehicleModelOptions?.filter(
      (c) => c?._id === vehicle?.model
    )[0]?.name;

    vehicle.stateName = capitalize(
      statesOptions?.filter((c) => c?._id === vehicle?.state)[0]?.name
    );
    vehicle.cityName = capitalize(
      citiesOptions?.filter((c) => c?._id === vehicle?.city)[0]?.name
    );
    vehicle.municipalityName = capitalize(
      municipalitiesOptions?.filter((c) => c?._id === vehicle?.municipality)[0]
        ?.name
    );

    const circulationCardBase64 = circulationCard
      ? await convertToBase64(circulationCard)
      : null;

    if (!isLoading) {
      if (!authService.getUser()) {
        const dataLayer = {
          event: 'funnel_step_vehicle_info',
          plan_category: `Planes de ${membership?.class}`,
          document_type: filterOptionById(
            vehicleDocumentTypeOptions,
            data?.documentTypeImage
          )?.name,
          vehicle_class: filterOptionById(vehicleClassesOptions, data?.class)
            ?.name,
          vehicle_type: filterOptionById(typesOptions, data?.type)?.name,
          plate: data?.plate,
          make: filterOptionById(vehicleBrandOptions, data?.brand)?.name,
          model: filterOptionById(vehicleModelOptions, data?.model)?.name,
          color: data?.color,
          vehicle_year: data?.year,
          vehicle_armored: watch('armorType') ? 'Si' : 'No',
          vehicle_owner: data?.customerIsOwner ? 'Si' : 'No',
          primary_driver: isVehicleDriver,
        };
        // If logged In
        window.dataLayer.push(dataLayer);
      }

      setIsloading(true);
      vehicleService
        .createVehicle(fileTopost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);

            // Store images in session storage
            let vehicleData = {
              circulationCardName: circulationCard.name,
              circulationCardUploaded: circulationCardBase64,
              documentTypeImage: watch('documentTypeImage'),
              ...vehicle,
            };

            sessionStorage.setItem('vehicle', JSON.stringify(vehicleData));
            setcurentStep(curentStep + 1);
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getAndSetCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
          const matchedCity = response?.data?.cities.find(
            (city) =>
              destinyRef.current.value &&
              typeof destinyRef.current.value === 'string' &&
              destinyRef.current.value
                .toLowerCase()
                .includes(city.name.toLowerCase())
          );

          if (matchedCity) {
            setValue('city', matchedCity._id);
            getMunicipalities(matchedCity._id);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getStates = useCallback(() => {
    statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          let states = response?.data?.states;

          if (selectedMembership?.code === planTypes?.MOTORIDERAV) {
            states = filterSatesMotoriderAV(states);
          }

          setStatesOptions(states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  }, [selectedMembership]);

  const handleCity = (e) => {
    getRCVCities(e.target.value);
  };

  const getOwnerCities = (ownerState) => {
    statesService
      .getCities(ownerState ? ownerState : watch('ownerState'), true)
      .then((response) => {
        if (response.status === 200) {
          setOwnerCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };
  const getRCVCities = (RCVCities) => {
    statesService
      .getCities(RCVCities ? RCVCities : watch('ownerState'), true)
      .then((response) => {
        if (response.status === 200) {
          setRCVCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getMunicipalities = (city) => {
    statesService
      .getMunicipalities(city ? city : watch('city'), true)
      .then((response) => {
        if (response.status === 200) {
          setMunicipalitiesOptions(response?.data?.municipalities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const appendFile = (rawData) => {
    let data = { ...rawData };

    const formData = new FormData();
    if (data.rcvHolder) {
      data.rcvHolder = JSON.stringify(data.rcvHolder);
    }
    for (const key in data) {
      formData.append(key, data[key]);
    }

    if (circulationCard) {
      formData.append('circulation-card', circulationCard);
    }

    if (saleChannel) {
      formData.append('landing', 'Marqueting qr');
    }
    formData.append('customer', customer);
    formData.append('membership', membership?._id);
    formData.append(
      'armored',
      watch('armorType') &&
        filterOptionById(armorTypeOptions, watch('armorType'))?.name !== 'No'
        ? 'true'
        : 'false'
    );
    return formData;
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop: onDrop1 });

  const getSalesVehicleClasses = useCallback(async () => {
    const { getCache, setCache } = useVehicleClassesStore.getState();
    const cachedData = getCache('vehicleClasses');
    
    if (cachedData && cachedData.classes) {
      setVehicleClassesOptions(cachedData.classes);
      return;
    }

    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
          setCache(response?.data?.classes, 'vehicleClasses', response?.data?.classes.length);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  }, []);

  const getArmorTypes = useCallback(() => {
    armorTypesService
      .getArmorTypes()
      .then((response) => {
        if (response.status === 200) {
          setArmorTypeOptions([...response?.data]);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  }, []);

  const preloadValues = () => {
    let vehicleData = sessionStorage.getItem('vehicle');
    vehicleData = JSON.parse(vehicleData);

    let circulationCardUploaded = '';

    if (!authService?.getUser()) {
      setValue('documentTypeImage', documentTypeEnum?.CERTIFICATE_OR_TITLE);
    }

    if (vehicleData) {
      // Read images from session storage
      circulationCardUploaded = convertBase64ToFile(
        vehicleData?.circulationCardUploaded,
        vehicleData.circulationCardName,
        'image/jpeg'
      );
      setcirculationCard(circulationCardUploaded);
      setValue('documentTypeImage', vehicleData?.documentTypeImage);
      setValue('year', vehicle?.year);
      setValue('bodySerial', vehicleData?.bodySerial);
      setValue('color', vehicleData?.color);
      setValue('plate', vehicleData?.plate);
      setValue('bodySerial', vehicleData?.bodySerial);
      // setValue('km', vehicleData?.km);

      // Insurance data
      setValue('seats', vehicleData?.seats);

      Promise.allSettled([
        getVehicleTypes(vehicleData?.class),
        getSalesVehicleClasses(),
        getVehicleBrands(),
        getVehicleModels(vehicleData?.brand),
        getArmorTypes(),
        getStates(),
        getCities(vehicleData?.state),
        getMunicipalities(vehicleData?.city),
      ]).then((r) => {
        setTimeout(() => {
          // Address info
          setValue('state', vehicleData?.state);
          setValue('city', vehicleData?.city);
          setValue('municipality', vehicleData?.municipality);
          setValue('address', vehicleData?.address);
          // Vehicle Info
          setValue('armorType', vehicleData?.armorType);
          setValue('class', vehicleData?.class);
          setValue('type', vehicleData?.type);
          setValue('brand', vehicleData?.brand);
          setValue('model', vehicleData?.model);
          setValue('type', vehicleData?.type);
        }, 500);
      });

      if (vehicleData?.customerIsOwner) {
        setValue('customerIsOwner', true);
        setcustomerIsOwner('SI');
      } else {
        setValue('customerIsOwner', false);
        setcustomerIsOwner('NO');
        setValue('ownerFirstName', vehicleData?.ownerFirstName);
        setValue('ownerLastName', vehicleData?.ownerLastName);
        setValue(
          'ownerIdentificationType',
          vehicleData?.ownerIdentificationType
        );
        setValue('ownerIdentification', vehicleData?.ownerIdentification);
        setValue('ownerAddress', vehicleData?.ownerAddress);

        Promise.allSettled([
          getStates(),
          getOwnerCities(vehicleData?.ownerState),
        ]).then((r) => {
          setTimeout(() => {
            setValue('ownerState', vehicleData?.ownerState);
            setValue('ownerCity', vehicleData?.ownerCity);
          }, 500);
        });
      }
      if (vehicleData?.rcvHolder?.isVehicleDriver) {
        setValue('isVehicleDriver', true);
        setIsVehicleDriver('SI');
      } else {
        setValue('isVehicleDriver', false);
        setIsVehicleDriver('NO');
        setValue('rcvHolderFirstName', vehicleData?.rcvHolder?.firstName);
        setValue('rcvHolderLastName', vehicleData?.rcvHolder?.lastName);
        setValue(
          'rcvHolderIdentificationType',
          vehicleData?.rcvHolder?.identificationType
        );
        setValue(
          'rcvHolderIdentification',
          vehicleData?.rcvHolder?.identification
        );
        setValue('rcvHolderPhonePrefix', vehicleData?.rcvHolder?.phonePrefix);
        setValue('rcvHolderPhoneNumber', vehicleData?.rcvHolder?.phoneNumber);
        setValue('rcvHolderAddress', vehicleData?.rcvHolder?.address);

        Promise.allSettled([
          getStates(),
          getRCVCities(vehicleData?.rcvHolder?.state),
        ]).then((r) => {
          setTimeout(() => {
            setValue('rcvHolderState', vehicleData?.rcvHolder?.state);
            setValue('rcvHolderCity', vehicleData?.rcvHolder?.city);
          }, 500);
        });
      }
    } else {
      setValue('year', vehicle?.year);
      setValue('customerIsOwner', true);
      Promise.allSettled([
        getVehicleTypes(vehicle?.class),
        getSalesVehicleClasses(),
        getArmorTypes(),
      ]).then((r) => {
        setTimeout(() => {
          setValue('armorType', vehicle?.armorType);
          setValue('class', vehicle?.class);
          setValue('type', vehicle?.type);
        }, 500);
      });
    }
  };

  const getVehicleTypes = (clase) => {
    return vehicleService
      .getVehicleTypes({ class: clase })
      .then((response) => {
        if (response.status === 200) {
          const types = response?.data?.types;
          setTypesOptions(types);
          return types;
        } else {
          notify(`${response.message}` || 'error', 'error');
          return [];
        }
      })
      .catch((error) => {
        return [];
      });
  };

  const getVehicleBrands = useCallback(() => {
    return vehicleService
      .getVehicleBrands(undefined, getVehicleBrandsPlanParam(selectedMembership))
      .then((response) => {
        if (response.status === 200) {
          const brandsData = response?.data?.vehicleBrands;
          setVehicleBrandOptions(brandsData);
          return brandsData;
        } else {
          notify(`${response.message}`, 'error');
          return [];
        }
      })
      .catch((error) => {
        return [];
      });
  }, [selectedMembership]);

  const getVehicleModels = (vehicleBrandId) => {
    return vehicleService
      .getVehicleModels(vehicleBrandId)
      .then((response) => {
        if (response.status === 200) {
          const models = response?.data?.models;
          setVehicleModelOptions(models);
          return models;
        } else {
          notify(`${response.message}`, 'error');
          return [];
        }
      })
      .catch((error) => {
        return [];
      });
  };

  const handlecustomerIsOwner = (e) => {
    if (e?.target?.value === 'SI') {
      setValue('customerIsOwner', true);
      setcustomerIsOwner(e?.target?.value);
      clearTitularForm();
    }
    if (e?.target?.value === 'NO') {
      setValue('customerIsOwner', false);
      setcustomerIsOwner(e?.target?.value);
      clearTitularForm();
    }
  };

  const handleRCVHolder = (e) => {
    if (e?.target?.value === 'SI') {
      setValue('isVehicleDriver', true);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
    if (e?.target?.value === 'NO') {
      setValue('isVehicleDriver', false);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
  };

  const clearTitularForm = () => {
    setValue('ownerFirstName', '');
    setValue('ownerLastName', '');
    setValue('ownerState', '');
    setValue('ownerCity', '');
    setValue('ownerAddress', '');
    setValue('ownerIdentificationType', '');
    setValue('ownerIdentification', '');
  };

  const clearRCVForm = () => {
    setValue('rcvHolderFirstName', '');
    setValue('rcvHolderLastName', '');
    setValue('rcvHolderIdentificationType', '');
    setValue('rcvHolderIdentification', '');
    setValue('rcvHolderState', '');
    setValue('rcvHolderCity', '');
    setValue('rcvHolderPhonePrefix', '');
    setValue('rcvHolderPhoneNumber', '');
    setValue('rcvHolderAddress', '');
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getStates();
      getVehicleBrands();
      preloadValues();
    }
  }, [getStates, getVehicleBrands]);

  let validateDisabled = () => {
    return false;
  };

  let validateIfshowForm = () => {
    if (saleChannel) {
      return true;
    }
    if (watch('documentTypeImage')) {
      return true;
    } else return false;
  };

  const preloadPage = async () => {
    setValue('documentTypeImage', documentTypeEnum?.CERTIFICATE_OR_TITLE);
    handleTestImageUpload(
      onDrop1,
      `${process.env.PUBLIC_URL}/TituloPrueba.jpeg`,
      'TituloPrueba.jpeg'
    );

    const classId = watch('class');
    const types = classId ? await getVehicleTypes(classId) : [];
    const typeId = resolvePreloadTypeId(types);

    getVehicleModels('6469228923c7f1fa25cd42a3');
    getCities('64695c7b447d0aa9c65969f7');
    getMunicipalities('64695ffba034e218fab88f15');
    getOwnerCities('64695c7b447d0aa9c65969f7');

    setTimeout(() => {
      preloadVehicleData(setValue, membership, null, watch, typeId);
    }, 1500);

    setTimeout(() => {
      setValue('plate', generateRandomPlate());
    }, 2500);
  };

  return (
    <>
      <LoadSpinner show={isLoading} />
      <div className="landing-form-container">
        <h5
          onClick={
            ['true', true].includes(process.env.REACT_APP_DEVELOP)
              ? () => preloadPage()
              : ''
          }
        >
          Información del Vehículo
        </h5>
        <p>(*) Campos obligatorios</p>
        <br />
        <form className="responsive-landing-form">
          <div className="row">
            <div className="col-12">
              <div className="buttons-center-container">
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Tipo de Documento *'}
                  type={'select'}
                  capitalizeOff={true}
                  name={'documentTypeImage'}
                  register={register}
                  placeholder={''}
                  options={
                    authService?.getUser()
                      ? vehicleDocumentTypeOptions
                      : externalvehicleDocumentTypeOptions
                  }
                  errors={errors?.documentTypeImage?.message}
                />
              </div>
              {validateIfshowForm() && (
                <>
                  {circulationCard ? (
                    <FileComponent
                      file={circulationCard}
                      remove={() => setcirculationCard('')}
                    />
                  ) : (
                    <SalesDropzone
                      // instructions={'Adjuntar carnet de circulación*'}
                      instructions={
                        'Adjuntar Título de propiedad del vehículo*'
                      }
                      maxWeight={'(JPG, PNG, PDF, máx. 3MB)'}
                      getRootProps={getRootProps}
                      getInputProps={getInputProps}
                      message="Arrastrar o buscar Documento"
                      error={vehileError}
                    />
                  )}
                </>
              )}
            </div>
            {validateIfshowForm() && (
              <>
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Clase *'}
                  type={'select'}
                  name={'class'}
                  register={register}
                  placeholder={''}
                  options={vehicleClassesOptions}
                  errors={errors?.class?.message}
                  disabled={true}
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Tipo *'}
                  type={'select'}
                  name={'type'}
                  register={register}
                  placeholder={''}
                  options={typesOptions}
                  errors={errors?.type?.message}
                  disabled={validateDisabled()}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Placa *'}
                  type={'text'}
                  name={'plate'}
                  register={register}
                  placeholder={''}
                  errors={errors?.plate?.message}
                  onChange={(e) =>
                    removeBlankSpacesAndUppercase(
                      watch('plate'),
                      'plate',
                      setValue
                    )
                  }
                  disabled={validateDisabled()}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Marca *'}
                  type={'select'}
                  options={vehicleBrandOptions}
                  name={'brand'}
                  register={register}
                  placeholder={''}
                  errors={errors?.brand?.message}
                  disabled={validateDisabled()}
                  onChange={() => getVehicleModels(watch('brand'))}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Modelo *'}
                  type={'select'}
                  name={'model'}
                  register={register}
                  placeholder={''}
                  options={vehicleModelOptions}
                  errors={errors?.model?.message}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Color *'}
                  type={'text'}
                  name={'color'}
                  register={register}
                  placeholder={''}
                  errors={errors?.color?.message}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Año *'}
                  type={'number'}
                  name={'year'}
                  register={register}
                  placeholder={''}
                  control={control}
                  errors={errors?.year?.message}
                  disabled={true}
                />
                {/* <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Kilometraje del vehículo'}
                  type={'number'}
                  name={'km'}
                  register={register}
                  placeholder={''}
                  errors={errors?.km?.message}
                  disabled={validateDisabled()}
                  min={'0'}
                /> */}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Blindaje'}
                  type={'select'}
                  options={armorTypeOptions}
                  name={'armorType'}
                  register={register}
                  errors={errors?.armorType?.message}
                  disabled={true}
                />{' '}
                <div className="input-component-container col-12 col-md-6">
                  <label>Dirección *</label>
                  <LoadScript
                    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    libraries={['places']}
                  >
                    <Autocomplete
                      restrictions={{ country: 've' }}
                      language="es"
                    >
                      <input
                        id="destinyRef"
                        className="input-map"
                        placeholder="Calle, Avenida, residencia o local"
                        ref={destinyRef}
                        style={{ fontSize: '12px', margin: '0px' }}
                        onClick={() => updateLocationStatus()}
                        onBlur={() => updateLocationStatus()}
                        onSelect={() => updateLocationStatus()}
                      />
                    </Autocomplete>
                  </LoadScript>
                </div>
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Estado *'}
                  type={'select'}
                  options={statesOptions}
                  name={'state'}
                  placeholder={'Seleccione'}
                  register={register}
                  errors={errors?.state?.message}
                  onChange={(e) => getCities(watch('state'))}
                  disabled={validateDisabled()}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Ciudad *'}
                  type={'select'}
                  options={citiesOptions}
                  name={'city'}
                  placeholder={'Seleccione'}
                  register={register}
                  errors={errors?.city?.message}
                  onChange={(e) => getMunicipalities()}
                  disabled={validateDisabled()}
                />{' '}
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'Municipio *'}
                  type={'select'}
                  options={municipalitiesOptions}
                  name={'municipality'}
                  placeholder={'Seleccione'}
                  register={register}
                  errors={errors?.municipality?.message}
                  disabled={validateDisabled()}
                />{' '}
                {membership?.rcv !== 'N/A' && (
                  <>
                    <h5
                      style={{
                        textAlign: 'center',
                        marginTop: '24px',
                        marginBottom: '12px',
                      }}
                    >
                      Información para RCV
                    </h5>
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Serial Carrocería* (en el carnet de circulación)'}
                      type={'text'}
                      name={'bodySerial'}
                      register={register}
                      placeholder={''}
                      errors={errors?.bodySerial?.message}
                      onChange={(e) =>
                        removeBlankSpacesAndUppercase(
                          watch('bodySerial'),
                          'bodySerial',
                          setValue
                        )
                      }
                      disabled={validateDisabled()}
                    />{' '}
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Puestos del Vehículo *'}
                      type={'number'}
                      name={'seats'}
                      register={register}
                      placeholder={''}
                      errors={errors?.seats?.message}
                    />
                  </>
                )}
                <div className="col-12 col-md-6 checbox-input-container">
                  <label htmlFor="">¿Eres el titular del vehículo?</label>
                  <div className="checbox-input-container-midle">
                    <div className="topping">
                      <input
                        type="checkbox"
                        id="topping"
                        name="customerIsOwner"
                        value={'SI'}
                        checked={customerIsOwner === 'SI'}
                        onChange={handlecustomerIsOwner}
                      />
                      Si
                    </div>{' '}
                    <div className="topping">
                      <input
                        type="checkbox"
                        id="topping"
                        name="customerIsOwner"
                        value={'NO'}
                        checked={customerIsOwner === 'NO'}
                        onChange={handlecustomerIsOwner}
                      />
                      No
                    </div>
                    <div className="result">
                      {/* Above checkbox is {isChecked ? 'checked' : 'un-checked'}. */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6"></div>
                {customerIsOwner === 'NO' ? (
                  <>
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Nombre del titular *'}
                      type={'text'}
                      name={'ownerFirstName'}
                      register={register}
                      placeholder={''}
                      errors={errors?.ownerFirstName?.message}
                    />
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Apellido del titular *'}
                      type={'text'}
                      name={'ownerLastName'}
                      register={register}
                      placeholder={''}
                      errors={errors?.ownerLastName?.message}
                    />{' '}
                    <Input
                      bootstrap={'col-4 col-sm-2 col-md-2'}
                      label={'C.I / RIF*'}
                      type={'select'}
                      name={'ownerIdentificationType'}
                      register={register}
                      placeholder={''}
                      options={idCodes}
                      errors={errors?.ownerIdentificationType?.message}
                    />{' '}
                    <Input
                      bootstrap={'col-8 col-sm-4 col-md-4'}
                      label={'del titular*'}
                      type={'number'}
                      name={'ownerIdentification'}
                      register={register}
                      placeholder={''}
                      errors={errors?.ownerIdentification?.message}
                    />{' '}
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Estado del titular *'}
                      type={'select'}
                      options={statesOptions}
                      name={'ownerState'}
                      placeholder={'Seleccione'}
                      register={register}
                      errors={errors?.ownerState?.message}
                      onChange={(e) => getOwnerCities()}
                    />{' '}
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Ciudad del titular *'}
                      type={'select'}
                      options={ownerCitiesOptions}
                      name={'ownerCity'}
                      placeholder={'Seleccione'}
                      register={register}
                      errors={errors?.ownerCity?.message}
                    />{' '}
                    <Input
                      bootstrap={'col-12 col-md-6'}
                      label={'Dirección del titular *'}
                      type={'textarea'}
                      name={'ownerAddress'}
                      placeholder={''}
                      register={register}
                      errors={errors?.ownerAddress?.message}
                    />
                  </>
                ) : null}
                <div className="col-12 col-md-3"></div>
              </>
            )}{' '}
            {membership?.rcv !== 'N/A' && validateIfshowForm() && (
              <RcvHolderForm
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                citiesOptions={RCVCitiesOptions}
                statesOptions={statesOptions}
                handleCity={handleCity}
                isVehicleDriver={isVehicleDriver}
                handleRCVHolder={handleRCVHolder}
              />
            )}
          </div>

          <div
            style={{ margin: '24px 0px 48px 0px' }}
            className="buttons-center-container"
          >
            <AltButton
              label={'Regresar'}
              action={() => setcurentStep(curentStep - 1)}
            />
            <ActionButton label={'Siguiente'} action={onSubmit} />
          </div>
        </form>
      </div>
    </>
  );
});
